export const formatDate = (date) => {
  return new Intl.DateTimeFormat("en-US",
    {
      year: "numeric",
      month: "short",
      day: "2-digit",
      weekday: "short",
      // hour12: false,
      hourCycle: 'h23',
      hour: "2-digit",
      minute: "2-digit",
      timeZone: "America/New_York",
    }).format(date);
};
